import { Inject, Injectable } from '@angular/core';
import { Subject, Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';

import { ApiCommonService } from 'cbc-shared-lib';

import { FeaturesLibConfig } from '../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../config/features-lib-config.token';

import { SgKdConstants } from '../sg-kd-constants';

import {
  SZZA001AService,
  Szza001aRequest,
  Szza001aResponse
} from 'sg-api';

@Injectable({
  providedIn: 'root'
})
export class UsedSzza001aService {

  private _rsesult$ = new Subject<Szza001aResponse>();

  // get contractorValueChanges(): Observable<Szza001aResponse> {
  //   return this._rsesult$.asObservable();
  // }

  constructor(
    private szza001aService: SZZA001AService,
    private apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig
  ) { }

  /**
   * 住所情報取得
   *
   * @param zipCode 郵便番号
   * @memberof UsedSzza001aService
   */
  doSzza012a(zipCode: string): Observable<Szza001aResponse> {

    // リクエスト情報生成
    let request: Szza001aRequest = {
      zipCode: zipCode
    };

    return this.szza001aService.a10RSZZA001APost(this.apiCommonService.setRequestCommon(request), 'response')
      // NOTE:component側に戻り値として値を返却したい場合は、pipe(map())処理内で値を返却する。
      .pipe(
        map(response => {
          // エラーが設定されていないかチェックする
          this.apiCommonService.checkError(response);
          this._rsesult$.next(response.body);
          return response.body;
        }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SZZA001A');
          return throwError(err.message);
        }
      )
    );
  }
}
